import { View } from 'react-native';
import { Props, Breed } from 'shared/@types';
import { Image } from 'shared/components/image';
import { Text } from 'shared/components/text';
import { Link } from 'shared/components/link';
import { useTranslation } from 'react-i18next';
import LikeButton from 'shared/components/like-button';
import { useStaticRoute } from 'shared/library/routes/route';
import { memo } from 'react';
import { getBreedImageAsset } from 'shared/library/get-model-image';
import { BreedName } from 'shared/components/breed-name';

const BreedCard = memo(function BreedCard({
  breed,
  showActiveCount,
}: Props<{ breed: Breed; showActiveCount?: boolean }>) {
  const { t } = useTranslation('components');
  const route = useStaticRoute();
  const breedImage = getBreedImageAsset(breed) ?? '';

  return (
    <View className={'relative hover:z-20'}>
      <View className={'absolute left-0 top-0 z-10 p-2'}>
        <LikeButton modelId={breed.id} modelType={'App\\Models\\Breed'} />
      </View>

      <Link
        containerClassName={'group bg-white'}
        href={route('breeds.show', { breed: breed.slug })}
        asBlock
      >
        <Image
          src={breedImage}
          alt={breed.name}
          containerClassName={'aspect-4/3 w-full'}
          imageClassName={'rounded-t object-cover group-hover:opacity-75'}
          sizeType={'card'}
        />
        <View className={'border-brand-brown-dark/15 rounded-b border border-t-0 p-3'}>
          <View className={'flex-row items-center gap-1.5'}>
            <Text
              className={'text-brand-brown-dark min-w-0 shrink font-bold group-hover:underline'}
            >
              <BreedName
                name={breed.name}
                animal={breed.animal}
                breedType={breed.breed_type}
                hasVerifiedPedigree={false}
              />
            </Text>
          </View>
          {showActiveCount && (
            <Text className={'text-brand-brown-dark/70 w-full min-w-0 text-sm'} numberOfLines={1}>
              {t(
                breed.animal === 'dog'
                  ? 'breed_card.puppies_available'
                  : 'breed_card.kittens_available',
                {
                  count: breed.active_pets_count,
                },
              )}
            </Text>
          )}
        </View>
      </Link>
    </View>
  );
});

export { BreedCard };
